import { put } from 'redux-saga/effects'
import { updateLabelAction } from '../../handles'
import { update, UpdateLabelResponse } from '../_http/label'

export function* updateLabelSaga(action: ReturnType<typeof updateLabelAction.request>) {
  const { labelId, dataToUpdate } = action.payload
  try {
    const { label }: UpdateLabelResponse = yield update(labelId, dataToUpdate)
    yield put(updateLabelAction.success({ id: labelId, ...label }))
  } catch (error) {
    yield put(updateLabelAction.failure())
  }
}
